import { Spinner } from '@opaz/ui-components';

type SigningInCoverProps = {
  title: string;
  subtitle: string;
};

export const SigningInCover = ({ title, subtitle }: SigningInCoverProps) => {
  return (
    <div className="flex justify-center items-center absolute left-0 top-0 w-full h-full bg-states-base-bg z-10">
      <div className="flex flex-col items-center">
        <Spinner className="mb-12 w-20 h-20" />
        <span className="block mb-6 text-[#1A444F] font-bold text-2xl">{title}</span>
        <span className="text-xl text-muted-foreground">{subtitle}</span>
      </div>
    </div>
  );
};
